// extracted by mini-css-extract-plugin
export default {"detailWrapper":"styles_detailWrapper__i79KP","showLogin":"styles_showLogin__EVe8o","logins":"styles_logins__r4544","loginTxt":"styles_loginTxt__7avfv"};